import shared from "emun.retailer/retailer.config.es6";

export default Object.assign(shared, {
  quickStartCustomer: false,
  hideRequestForm: true,
  hideInactiveLocationsB2B: true,
  hideStoreType: true,
  routes: [
    { name: "dashboard", title: "Account Dashboard" },
    {
      name: "profile",
      title: "Account Details",
    },
    { name: "orders", title: "Orders" },
    { name: "shipping-locations", title: "Addresses", hidden: false },
    {
      name: "lists",
      url: "/lists?listId&ListId",
      title: "Lists",
    },
  ],
});
